// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProgressLoadIcon__icon-c6040b {
  flex-shrink: 0;
  vertical-align: middle;
  fill: currentColor;
  cursor: pointer;
  transform: rotate(-90deg);
}

.ProgressLoadIcon__icon-c6040b circle {
  stroke: currentColor;
  stroke-linecap: round;
  stroke-width: 2px;
  stroke-dasharray: 100;
}`, "",{"version":3,"sources":["webpack://./src/main/components/ProgressLoadIcon/ProgressLoadIcon.styles.m.css"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AACF;;AAEA;EACE,oBAAA;EACA,qBAAA;EACA,iBAAA;EACA,qBAAA;AACF","sourcesContent":[".icon {\n  flex-shrink: 0;\n  vertical-align: middle;\n  fill: currentColor;\n  cursor: pointer;\n  transform: rotate(-90deg);\n}\n\n.icon circle {\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-width: 2px;\n  stroke-dasharray: 100;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `ProgressLoadIcon__icon-c6040b`
};
module.exports = ___CSS_LOADER_EXPORT___;
